/**
 * Free Medical Page
 *
 * 自由診療メニュー - マスタメンテナンス
 * Display and manage free medical treatments with tabbed interface.
 * Shared by A2 and R2 (HIT-14562).
 */

import React, { useState } from 'react';
import type { TabsProps } from 'antd';
import { useMainFreeMedicalInit } from '@/hooks/main/useMainFreeMedical';
import { AppSpin, AppTabs } from '@/components/atoms';
import CategoryTab from './tabs/CategoryTab';
import TreatmentTypeTab from './tabs/TreatmentTypeTab';
import { FreeMedicalInitData } from './types';

/**
 * Main FreeMedicalPage Component
 */
const FreeMedicalPage: React.FC = () => {
  // Tab state
  const [activeTab, setActiveTab] = useState<'category' | 'treatment'>('category');

  // init data for dropdowns etc
  const { data: initResponse, isLoading: initLoading } = useMainFreeMedicalInit();
  const initData: FreeMedicalInitData | null = initResponse?.data || null;

  if (initLoading) {
    return (
      <div
        className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-3 rounded-md bg-white/80"
        aria-busy="true"
      >
        <AppSpin size="large" />
      </div>
    );
  }
  return (
    <AppTabs
      activeKey={activeTab}
      onChange={key => setActiveTab(key as 'category' | 'treatment')}
      items={
        [
          {
            key: 'category',
            label: 'カテゴリ',
            children: <CategoryTab initData={initData} />,
          },
          {
            key: 'treatment',
            label: '自由診療',
            children: <TreatmentTypeTab initData={initData} />,
          },
        ] as TabsProps['items']
      }
    />
  );
};

export default FreeMedicalPage;
